/**
 *  © 2015 -2022 HCL Technologies Limited, all rights reserved.
 *  Material published by HCL Technologies on these web pages/mobile
 *  app may not be reproduced without permission.
 */

import React, { useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import ImgCrop from '../../Common/ImgCrop';
const HeroImage = (props) => {
  const { heroItem, renderQna, data } = props;
  useEffect(() => {
    renderQna('heroItem');
  }, [data]);

  return (
    <div className="question__hero">
      <div className="question__hero-image">
        <div className="grid-12">
          <div className="mu-content">
            <div className="mu-item">
              <div className="img-holder">
                {heroItem &&
                  heroItem.templateDetail_info &&
                  heroItem.templateDetail_info.heroItem &&
                  heroItem.templateDetail_info.heroItem.CropUrl && (
                    <ImgCrop
                      imgCrop={heroItem.templateDetail_info.heroItem.CropUrl}
                      singleSrc={false}
                      alt=""
                      title={data.Title && data.Title.value}
                    ></ImgCrop>
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default withTranslation()(HeroImage);
